// routes
import { PATH_AUTH } from '../routes/paths';
// utils - IMPORTANT: use the configured axiosInstance (with baseURL), not the raw axios
import axios from '../utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    localStorage.removeItem('accessToken');

    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    // Strip "Bearer " prefix if present, to store only the raw JWT in localStorage
    // (jwtDecode needs the raw JWT without the "Bearer " prefix)
    const rawToken = accessToken.startsWith('Bearer ') 
      ? accessToken.slice(7) 
      : accessToken;

    localStorage.setItem('accessToken', rawToken);

    // Always send "Bearer " + raw token in Authorization header
    axios.defaults.headers.common.Authorization = `Bearer ${rawToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(rawToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
  }
};
